// client/src/components/auth/RequireAuth.js
import { Navigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

function RequireAuth({ children }) {
  const { isLoggedIn, loading, user } = useAuth()

  if (loading) return <p>Loading...</p>
  if (!isLoggedIn) return <Navigate to="/landing" replace />
  if (isLoggedIn && user && !user.email_verified) {
    // Block access to protected pages until email is verified
    return <Navigate to="/verify-email-pending" replace />
  }

  return children
}

export default RequireAuth
